export default Object.freeze({
    ACTIVE_CONTENT_BANNER: 'active-banner',
    COOKIE_CONSENT: 'no-consent', // no cookie consent given by user
})
